module.exports = __webpack_public_path__ + "static/img/empty-section-right.f14c8c9f.svg";